import { QRCodeSVG } from 'qrcode.react';
import React, { useRef, useContext } from 'react';

import {
  Card,
  Stack,
  Button,
  Dialog,
  Typography,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@mui/material';

import { useBoolean } from 'src/hooks/use-boolean';

import { DashboardContext } from 'src/context/dashboard/dashboard-context';

import { Iconify } from 'src/components/iconify';

function QRButton() {
  const { selectedRestaurant } = useContext(DashboardContext);
  const boolean = useBoolean();

  const qrCodeRef = useRef<SVGSVGElement>(null);

  const downloadQRCode = () => {
    const svg = qrCodeRef.current;

    if (svg) {
      const copySvg = svg.cloneNode(true) as SVGSVGElement;

      copySvg.setAttribute('width', '512');
      copySvg.setAttribute('height', '512');
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.src = `data:image/svg+xml;base64,${btoa(new XMLSerializer().serializeToString(copySvg))}`;
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx?.drawImage(img, 0, 0);
        const pngData = canvas.toDataURL('image/png');
        const a = document.createElement('a');
        a.href = pngData;
        a.download = 'restoran-menu-qr.png';
        a.click();
      };
    }
  };

  const qrCodeUrl = `${import.meta.env.VITE_MENU_URL}/${selectedRestaurant?._id}`;

  return (
    <>
      <Button
        variant="contained"
        fullWidth
        startIcon={<Iconify icon="ic:round-qr-code" />}
        onClick={boolean.onTrue}
      >
        QR Kodunu Görüntüle
      </Button>
      <Dialog
        open={boolean.value}
        onClose={boolean.onFalse}
        maxWidth="xs"
        PaperProps={{ sx: { bgcolor: 'background.neutral' } }}
        fullWidth
      >
        <DialogTitle>Restoranınızın QR Kodu</DialogTitle>
        <DialogContent>
          <Stack alignItems="center">
            <Card sx={{ width: 'fit-content', p: 2 }} elevation={22}>
              <QRCodeSVG ref={qrCodeRef} value={qrCodeUrl} size={200} />
            </Card>

            <Typography
              variant="caption"
              fontSize="0.825rem"
              sx={{
                textAlign: 'center',
                mt: 2,
              }}
            >
              QR kodunuzu resim olarak indirip, misafirlerinize istediğiniz şekilde sunabilirsiniz.
            </Typography>
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button variant="soft" onClick={boolean.onFalse}>
            Kapat
          </Button>
          <Button variant="contained" onClick={downloadQRCode}>
            Resim Olarak İndir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default QRButton;
